"use client";

import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const benefits = [];
export default function WhyWorkWithUs() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section className="bg-background overflow-hidden ![padding:64px_24px_64px_24px]">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          <div ref={imageRef} className={cn("relative transition-all duration-800 ease-out transform", isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12")}>
            <div className="relative z-10 rounded-sm overflow-hidden shadow-2xl">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606874/img/image_9238m6t1.jpg" alt="Expertise et Conseil" className="object-cover aspect-[4/3] !w-[580px] !h-[550px]" />
            </div>
            <div className="mt-8 space-y-4 relative z-10">
              
            </div>
            <div className="absolute -bottom-6 -left-6 w-48 h-48 bg-secondary/10 -z-0 rounded-sm" />
          </div>

          
          <div ref={textRef} className={cn("flex flex-col justify-center h-full transition-all duration-800 ease-out delay-200 transform", isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
            <h2 className="font-serif text-4xl text-primary mb-4 leading-tight !font-normal lg:text-5xl">Une approche qui transforme les contraintes réglementaires en leviers de performance</h2>
            
            
            <p className="font-sans text-lg text-card-foreground mb-6 leading-relaxed">Je suis <strong>Christelle CHARRIER-ROBELIN</strong>, fondatrice d'Effet Conseil. Le positionnement du cabinet est unique : avant de le créer en 2018, j'ai exercé des fonctions opérationnelles et de direction dans la formation professionnelle. Cette expérience terrain permet de comprendre vos réalités quotidiennes, vos contraintes organisationnelles et vos enjeux stratégiques.</p>
            <div className="h-1 bg-primary mb-10 !w-[96px]" />

            <div className="space-y-4 mb-10">
              
              
            </div>

            
            <div className="flex flex-col gap-4 mb-12">
              {benefits.map((benefit, i) => <div key={i} data-index={i} className="flex items-start gap-4 group">
                  <div className="mt-1 flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center transition-colors group-hover:bg-primary/20">
                    <Check className="w-4 h-4 text-primary" strokeWidth={3} />
                  </div>
                  
                </div>)}
            </div>

            <div className="flex flex-wrap gap-4">
              <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-white rounded-sm px-8">
                
              </Button>
              <Button asChild variant="outline" size="lg" className="border-primary text-primary hover:bg-primary/5 rounded-sm px-8">
                
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}